const state = {
  selectedObj: null,
  canvas: null,
  frontCard: null,
  canvasState: null, 
  undoList: [], // 撤销列表
  redoList: [], // 恢复列表
}
const mutations = {
  SET_CURSELECTEDOBJ: (state, selectedObj) => {
    state.selectedObj = selectedObj
  },
  SET_CANVAS: (state, canvas) => {
    state.canvas = canvas
  },
  INIT_FRONTCARD: (state, fCanvas) => {
    state.frontCard = fCanvas
  },
  SET_CANVASSTATE: (state, canvasState) => {
    state.canvasState = canvasState
  },
  ADD_UNDO: (state, canvasState) => {
    state.undoList.push(canvasState)
  },
  POP_UNDO: (state) => {
    state.undoList.pop()
  },
  ADD_REDO: (state, canvasState) => {
    state.redoList.push(canvasState)
  },
  POP_REDO: (state) => {
    state.redoList.pop()
  },
  SET_REDOLIST: (state, list) => {
    state.redoList = list
  },
}
const getters = {
  selectedObj: state => state.selectedObj,
  canvas: state => state.canvas,
  frontCard: state => state.frontCard,
  canvasState: state => state.canvasState,
  undoList: state => state.undoList,
  redoList: state => state.redoList,
  previewImg: state => state.previewImg,
}
const actions = {
  setSelectedObj({commit}, selectedObj) {
    commit('SET_CURSELECTEDOBJ', selectedObj)
  },
  setCanvas({commit}, canvas) {
    commit('SET_CANVAS', canvas)
  },
  initFrontCard({commit}, fCanvas) {
    commit('INIT_FRONTCARD', fCanvas)
  },
  setCanvasState({commit}, canvasState) {
    commit('SET_CANVASSTATE', canvasState)
  },
  addUndo({commit}, canvasState) {
    commit('ADD_UNDO', canvasState)
  },
  popUndo({commit}) {
    commit('POP_UNDO')
  },
  addRedo({commit}, canvasState) {
    commit('ADD_REDO', canvasState)
  },
  popRedo({commit}) {
    commit('POP_REDO')
  },
  setRedo({commit}, list) {
    commit('SET_REDOLIST', list)
  },
  saveState({commit, state}) {
    // 清空恢复栈redoList
    commit('SET_REDOLIST', [])

    if (state.canvasState) {
      commit('ADD_UNDO', state.canvasState)
    }
    commit('SET_CANVASSTATE', state.frontCard.toJSON([
      // 自定义参数
      'deviceInfo',
      'direction',
      'CustomType',
      'SYSPOINT',
      'warterDire',
      'ImgSrc',
      'checkListPar',
      'id',
      'label',
    ]))

    // console.log(state.canvasState)
  },
  // 撤销
  undo({commit, state}) {
    commit('ADD_REDO', state.canvasState)
    const lastState = {...state.undoList[state.undoList.length - 1]}
    commit('SET_CANVASSTATE', lastState)
    commit('POP_UNDO')
    state.frontCard.loadFromJSON(lastState,state.frontCard.renderAll.bind(state.frontCard), (o,object) => {
      console.log(object);
      if(object.type == "line" && object.CustomType == "WATER_PIPE_LINE"){
        object.setControlsVisibility({  
            bl: false,
            br: false, 
            tl: false, 
            tr: false,
            mtr: false, 
            mr: object.direction =='col'?false:true,
            ml: object.direction =='col'?false:true,
            mt: object.direction =='row'?false:true,
            mb: object.direction =='row'?false:true,
        });
      }
      
    })
    state.frontCard.renderAll()
  },
  // 恢复
  redo({commit, state}) {
    commit('ADD_UNDO', state.canvasState)
    const lastState = {...state.redoList[state.redoList.length - 1]}
    commit('SET_CANVASSTATE', lastState)
    commit('POP_REDO')
    console.log('lastState', lastState)
    state.frontCard.loadFromJSON(lastState,state.frontCard.renderAll.bind(state.frontCard), (o,object) => {
      if(object.type == "line" && object.CustomType == "WATER_PIPE_LINE"){
        object.setControlsVisibility({  
            bl: false,
            br: false, 
            tl: false, 
            tr: false,
            mtr: false, 
            mr: object.direction =='col'?false:true,
            ml: object.direction =='col'?false:true,
            mt: object.direction =='row'?false:true,
            mb: object.direction =='row'?false:true,
        });
      }
      
    })
    state.frontCard.renderAll()
  }
}
export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
};
